const PUBLIC_URL = window.PUBLIC_URL;

let EnvConfig =
{
/*****************************************************************************/
Environment:
{
	DEV				: 0,
	STAGING			: 1,
	PRODUCTION		: 2,
	LOCAL			: 3,
},

 // Please do not change these, as they affect KeyCloak, as well.
EnvStrings:
[
    "dev",
    "staging",
    "prod",
	"local",
],
/*****************************************************************************/
isReleaseMode: false,
environment: 2,

// This is the target when running the local Warehouse
localEnvTarget: 0,

isEnvSet: false,
/*****************************************************************************/
getIsReleaseMode()
{
	return EnvConfig.isReleaseMode;
},
/*****************************************************************************/
setIsReleaseMode(bValue)
{
	EnvConfig.isReleaseMode = bValue;
},
/*****************************************************************************/
getIsEnvSet()
{
    return EnvConfig.isEnvSet;
},
/*****************************************************************************/
autoDetectEnvironment()
{
    const queryString = new URLSearchParams(window.location.search);

    let isRunningLocally = false;
    if(window.location.href.indexOf('localhost:') >= 0
        || window.location.href.indexOf('127.0.0.1:') >= 0)
        isRunningLocally = true;

    let envOverride;
    if(isRunningLocally)
	{
        envOverride = EnvConfig.Environment.DEV;
		const envParam = queryString.get('env');
    	if(envParam === 'staging' || window.location.href.indexOf('env%3Dstaging') >= 0)
    		envOverride = EnvConfig.Environment.STAGING;
    	else if(envParam === 'production' || envParam === 'prod' || window.location.href.indexOf('forcewww=true') >= 0 || window.location.href.indexOf('env%3Dprod') >= 0)
    		envOverride = EnvConfig.Environment.PRODUCTION;
    	else if(envParam === 'local')
    		envOverride = EnvConfig.Environment.LOCAL;
	}
    else
	{
        const url = window.location.href;
    	if(url.indexOf("dev.modsy") >= 0)
    		envOverride = EnvConfig.Environment.DEV;
    	else if(url.indexOf("staging.modsy") >= 0)
    		envOverride = EnvConfig.Environment.STAGING;
    	else
    		envOverride = EnvConfig.Environment.PRODUCTION;
	}
    EnvConfig.setEnvironment(envOverride);
    EnvConfig.setIsReleaseMode(!isRunningLocally);

},
/*****************************************************************************/
getEnvironment()
{
    if(!EnvConfig.getIsEnvSet())
        console.error(`EnvConfig.getKeyCloakEnvironment: Trying to get environment before it has been set; please call EnvConfig.setEnvironment() first.`);

	return EnvConfig.environment;
},
/*****************************************************************************/
setEnvironment(eValue)
{
	EnvConfig.environment = eValue;
    EnvConfig.isEnvSet = true;
},
/*****************************************************************************/
getLocalEnvTarget()
{
	return EnvConfig.localEnvTarget;
},
/*****************************************************************************/
setLocalEnvTarget(eValue)
{
	EnvConfig.localEnvTarget = eValue;
},
/*****************************************************************************/
getEnvName()
{
	return EnvConfig.EnvStrings[EnvConfig.getEnvironment()];
},
/*****************************************************************************/
getCompanySlug()
{
	const env = EnvConfig.getEnvironment();

	let defaultSlug = 'e2e';
	if(env === EnvConfig.Environment.PRODUCTION) {
		defaultSlug = 'lennar';
	}

	// Infer the company slug from the hostname
	let subdomainSlug;
	const isPublicHostname = window.location.hostname.match(/^(?:.*\.)?modsy\.com$/);
	if (isPublicHostname) {
		subdomainSlug = window.location.hostname.split('.')[0];

		// If the leftmost subdomain is 'www' or 'app', then we don't want to use it
		if (['www', 'app'].includes(subdomainSlug)) {
			subdomainSlug = undefined;
		}
	}

	return subdomainSlug || defaultSlug;
},
/*****************************************************************************/
getWarehouseDownloadBaseUrl()
{
    if(window.__MODSY_ASSET_URL && EnvConfig.getIsReleaseMode())
    {
        let strRes = window.__MODSY_ASSET_URL;
        if(!strRes.endsWith("/"))
            strRes += "/";
        return strRes;
    }

	const currEnv = EnvConfig.getEnvironment();
	const localEnvTarget = EnvConfig.getLocalEnvTarget();
    if(currEnv === EnvConfig.Environment.DEV || (currEnv === EnvConfig.Environment.LOCAL && localEnvTarget === EnvConfig.Environment.DEV))
    	return "https://modsy-dev.s3.us-west-2.amazonaws.com/";
    else if(currEnv === EnvConfig.Environment.STAGING || (currEnv === EnvConfig.Environment.LOCAL && localEnvTarget === EnvConfig.Environment.STAGING))
    	return "https://modsy-staging.s3.us-west-2.amazonaws.com/";
    else if(currEnv === EnvConfig.Environment.PRODUCTION || (currEnv === EnvConfig.Environment.LOCAL && localEnvTarget === EnvConfig.Environment.PRODUCTION))
    	return "https://modsy.s3.us-west-2.amazonaws.com/";
    else
    {
        console.error("Unknown environment: " + currEnv);
        return "https://modsy-dev.s3.us-west-2.amazonaws.com/";
    }

},
/*****************************************************************************/
getModsyUrl(bAddSlash = true)
{
	const strSuffix = bAddSlash ? '/' : '';
    if(EnvConfig.getIsReleaseMode())
    {
    	// In the release mode, we just get our window base address
    	let strBaseUrl = window.location.protocol + '//' + window.location.host + strSuffix;
    	return strBaseUrl;
    }

    // And in local dev mode, we return one that depends on the environment
	const currEnv = EnvConfig.getEnvironment();
    if(currEnv === EnvConfig.Environment.LOCAL)
    	return "http://localhost:8000" + strSuffix;
    else if(currEnv === EnvConfig.Environment.DEV)
    	return "https://www.dev.modsy.com" + strSuffix;
    else if(currEnv === EnvConfig.Environment.STAGING)
    	return "https://www.staging.modsy.com" + strSuffix;
    else if(currEnv === EnvConfig.Environment.PRODUCTION)
    	return "https://www.modsy.com" + strSuffix;
    else
    {
        console.error("Unknown environment: " + currEnv);
        return "https://www.dev.modsy.com" + strSuffix;
    }
},
/*****************************************************************************/
getOpsUrl()
{
    // And in local dev mode, we return one that depends on the environment
	const currEnv = EnvConfig.getEnvironment();
    if(currEnv === EnvConfig.Environment.LOCAL)
        return "https://ops.dev.modsy.com/";
    else if(currEnv === EnvConfig.Environment.DEV)
    	return "https://ops.dev.modsy.com/";
    else if(currEnv === EnvConfig.Environment.STAGING)
    	return "https://ops.staging.modsy.com/";
    else if(currEnv === EnvConfig.Environment.PRODUCTION)
    	return "https://ops.modsy.com/";
    else
    {
        console.error("Unknown environment: " + currEnv);
        return "https://ops.dev.modsy.com/";
    }
},
/*****************************************************************************/
getModsyWarehouseUrl()
{
    if(window.__MODSY_API_URL && EnvConfig.getIsReleaseMode())
    {
        let strRes = window.__MODSY_API_URL;
        if(!strRes.endsWith("/"))
            strRes += "/";
        return strRes;
    }

    // Please do *not* use "localhost" instead of 127.0.0.1, as
    // this breaks Chrome running locally and results in
    // connection reset errors for any POST requests.
	const currEnv = EnvConfig.getEnvironment();
    if(currEnv === EnvConfig.Environment.LOCAL)
        return "http://127.0.0.1:8000/";
    else if(currEnv === EnvConfig.Environment.DEV)
        return "https://www.warehouse.dev.modsy.com/";
    else if(currEnv === EnvConfig.Environment.STAGING)
        return "https://www.warehouse.staging.modsy.com/";
    else if(currEnv === EnvConfig.Environment.PRODUCTION)
        return "https://www.warehouse.modsy.com/";
    else
    {
        console.error("Unknown environment: " + currEnv);
        return "https://www.warehouse.dev.modsy.com/";
    }
},
/*****************************************************************************/
getImgIxBaseUrl()
{
	const currEnv = EnvConfig.getEnvironment();
	if(currEnv === EnvConfig.Environment.DEV || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.DEV))
		return "https://modsy-dev.imgix.net/";
	else if(currEnv === EnvConfig.Environment.STAGING || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.STAGING))
		return "https://modsy-staging.imgix.net/";
	else if(currEnv === EnvConfig.Environment.PRODUCTION || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.PRODUCTION))
		return "https://modsy-prod.imgix.net/";
	else
	{
		console.error("Unknown environment: " + currEnv);
		return "https://modsy-dev.imgix.net/";
	}
},
/*****************************************************************************/
getCacheBaseUrl()
{
	const currEnv = EnvConfig.getEnvironment();
	if(currEnv === EnvConfig.Environment.DEV || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.DEV))
		return "https://cache-dev.modsy.com/";
	else if(currEnv === EnvConfig.Environment.STAGING || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.STAGING))
		return "https://cache-staging.modsy.com/";
	else if(currEnv === EnvConfig.Environment.PRODUCTION || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.PRODUCTION))
		return "https://cache.modsy.com/";
	else
	{
		console.error("Unknown environment: " + currEnv);
		return "https://cache-dev.modsy.com/";
	}
},
getImgBaseUrl()
{
	return EnvConfig.getCacheBaseUrl() + "imgresize-tim/";
},
/*****************************************************************************/
getWarehouseLoginUrl()
{
    return EnvConfig.getModsyWarehouseUrl() + "api-token-auth/";
},
/*****************************************************************************/
getWarehouseJWTVerifyUrl()
{
    return EnvConfig.getModsyWarehouseUrl() + "api-token-verify/";
},
/*****************************************************************************/
getWarehouseApiUrl(strApiPoint, app = 'warehouse')
{
    return EnvConfig.getModsyWarehouseUrl() + app + "/api/" + strApiPoint;
},
/*****************************************************************************/
getStudioUrl(spaceId)
{
    return EnvConfig.getModsyUrl() + "studio/" + spaceId;
},
/*****************************************************************************/
getProjectsUrl(spaceId)
{
	let url = `${EnvConfig.getModsyUrl()}projects`;
	if(spaceId)
		url += `/${spaceId}`;
	return url;
},
/*****************************************************************************/
getFullPathToLocalObject(strLocalPath)
{
    return strLocalPath;
    /*
	if(PUBLIC_URL === undefined || PUBLIC_URL === null || PUBLIC_URL.length === 0)
		return strLocalPath;

	// Handle potential full-path public URLS
	if(PUBLIC_URL.indexOf('http:') === 0 || PUBLIC_URL.indexOf('https:') === 0)
		return PUBLIC_URL + strLocalPath;

	return EnvConfig.getModsyUrl(false) + PUBLIC_URL + strLocalPath;
    */
},
/*****************************************************************************/
getKeyCloakEnvironment()
{
    const currEnv = EnvConfig.getEnvironment();
	if(currEnv === EnvConfig.Environment.PRODUCTION)
		return "prod";
	else if(currEnv === EnvConfig.Environment.STAGING)
		return "staging";
	else
        return "dev";
},
/*****************************************************************************/
getTimCacheBaseUrl()
{
	const currEnv = EnvConfig.getEnvironment();
	if(currEnv === EnvConfig.Environment.DEV || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.DEV))
		return "https://cache-dev.modsy.com/imgresize-tim/";
	else if(currEnv === EnvConfig.Environment.STAGING || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.STAGING))
		return "https://cache-staging.modsy.com/imgresize-tim/";
	else if(currEnv === EnvConfig.Environment.PRODUCTION || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.PRODUCTION))
		return "https://cache.modsy.com/imgresize-tim/";
	else
	{
		console.error("Unknown environment: " + currEnv);
		return "https://cache-dev.modsy.com/imgresize-tim/";
	}
},
/*****************************************************************************/
getNewAssetLibBaseUrl()
{
	const currEnv = EnvConfig.getEnvironment();
	if(currEnv === EnvConfig.Environment.DEV || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.DEV))
		return "https://www.dev.modsy.com/al/";
	else if(currEnv === EnvConfig.Environment.STAGING || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.STAGING))
		return "https://www.staging.modsy.com/al/";
	else if(currEnv === EnvConfig.Environment.PRODUCTION || (currEnv === EnvConfig.Environment.LOCAL && EnvConfig.localEnvTarget === EnvConfig.Environment.PRODUCTION))
		return "https://www.modsy.com/al/";
	else
	{
		console.error("Unknown environment: " + currEnv);
		return "https://www.dev.modsy.com/al/";
	}
},
/*****************************************************************************/
};

export default EnvConfig;
